import { Button, DataSource, HorizontalSpacer, Label, Layout, Panel, SearchButton, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTablePropertyList extends Layout {
    buttonResetForm: Button;
    buttonSearchTableProperty: SearchButton;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    labelAuditing: Label;
    labelHeader: Label;
    panelAuditing: Panel;
    panelSearch: Panel;
    sourceTableProperty: DataSource;
    switchHeaderIsAudited: Switch;
    switchHeaderIsAuditedDelete: Switch;
    switchHeaderIsAuditedInsert: Switch;
    switchHeaderIsAuditedUpdate: Switch;
    switchHeaderIsBroadcasted: Switch;
    switchHeaderIsQueryRestrict: Switch;
    switchHeaderIsShared: Switch;
    tableTableProperty: Table;
    textboxDaysToKeep: Textbox;
    textboxTableName: Textbox;
}
